import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function FeaturedMovies() {
  const featuredMovies = movies.filter((m) => m.featured);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              编辑精选，品质保证
            </p>
          </div>
          <a
            href="/category/juqing"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE("/category/juqing");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}